import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

export const API_URL = API_BASE;

export function apiError(e) {
    const d = e?.response?.data?.detail;
    if (d == null) return e?.message || "Something went wrong";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join("; ");
    return typeof d === "object" ? (d.msg || JSON.stringify(d)) : String(d);
}
